import cn from 'classnames';
import React from 'react';

import styles from './FadeText.module.less';

export function FadeText({ visible, left, right, top, bottom, children }) {
  return (
    <span
      className={cn(styles.text, !visible && styles.hidden)}
      style={{ left, right, top, bottom }}
    >
      {children}
    </span>
  );
}

export function FadeRoot({ as: Component = 'span', children, ...props }) {
  return (
    <Component {...props} className={cn(styles.root, props.className)}>
      {children}
    </Component>
  );
}
